import ElementSetting from '@/components/sections/builder/elements/body/collection-list-page/setting';
import ElementContent from '@/components/sections/builder/elements/body/collection-list-page/content';
import { CollectionListPageElementDataType } from '@/components/sections/builder/elements/body/collection-list-page/type';
import { Tags } from 'lucide-react';

const defaultData: CollectionListPageElementDataType = {
  name: 'Collection list page',
  heading: 'Collection list page',
  imageRatio: 'square',
  totalCol: 3,
  totalColMobile: 2,
  contentAlign: 'left',
  sortingCollection: '',
  showCategory: true,
  headingSize: 'small',
  size: 'small',
  borderRadius: 0,
};

export const ElementPreviewIcon = Tags;

const CollectionListPage = {
  type: 'collection_list_page',
  group: 'body_collection_list',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [],
  childs: [],
  maxEntries: 1,
  isImmutable: true,
};

export default CollectionListPage;
